import { Col, Row } from "antd";
import "./instructions.css";

export const Instructions = () => {
  return (
    <>
    <Row className="centred-div">
      <Col span={20}>
        <h2>First steps:</h2>
        <ol>
          <li>Download zip file.</li>
          <li>Unzip the file.</li>
          <li>Open Terminal - depending on your operating system</li>
          <li>In Terminal, enter the folder where the ZIP filw as extracted (Please note you need to choose the proper file relevant for your operating system).</li>
          <li>In Linux run chmod +x on storageCli executable</li>
          <li>You are set up for using storageCLI</li>
          <li>The file path should be used when running each command.</li>
        </ol>
        <h2>There are two modes of Uploading files by this tool:</h2>

        <ol>
          <li>
            <h3>Single file upload</h3>
            <p>For example:</p>
            <code>
              c:\src\bin\win-x64\storageCli.exe upload -d "DevTest/partialFolder2" -i "c:\temp\ldm\singleFile.txt" -m "Identifier=EXP123456" "Title=That is a folder upload"
            </code>
            <p>
              Here we upload a file selected by parameter{" "}
              <code>-i C:\temp\ldm\singleFile.txt</code>
            </p>
            <p>
              We upload to the default container (set in application.json config file)
            </p>
            <p>
              And we upload it to the destination folder (-d){" "} <code>DevTest/partialFolder2</code>
            </p>
            <p>
              Metadata keys are taken from file “template.json” that is in
              storageCli folder - but using <code>-m</code> parameter we are
              overriding 2 keys - "Identifier=EXP123456" and "Title=That is a folder upload"
            </p>
          </li>

          <li>
            <h3>Directory upload.</h3>
            <p>We have two modes here:</p>

            <p>
              <strong>
                a. Only the files from the selected folder are uploaded (-r -recursive flag is omitted or set to false)
              </strong>
            </p>
            <code>
              c:\src\bin\win-x64\storageCli.exe upload -d "DevTethatst/partialFolder2" -f C:\temp\ldm -m "Identifier=EXP123456" "Title=That is a folder upload"
            </code>

            <p>
              <strong>
                b. All the files from this folder and sub-folders are uploaded -r flag is added
              </strong>
            </p>
            <code>
              c:\src\bin\win-x64\storageCli.exe upload -r -d "DevTethatst/partialFolder2" -f C:\temp\ldm -m "Identifier=EXP123456" "Title=That is a folder upload"
            </code>

            <p>
              In directory upload, <code>-f</code> (folder) parameter is used
              instead of <code>-i</code> (input file) parameter.
            </p>
          </li>
        </ol>

        <p>
          When the storage CLI is run with no parameters – help is displayed.
        </p>
        <p>
          <code>storageCli.exe help upload</code> will show help and all
          parameters available.
        </p>

        <p>Additional important parameters:</p>
        <ul>
          <li>
            <code>-c</code> - change the default container – which is important
            if you want to test out on UAT instance with your dev container that
            is set there
          </li>
          <li>
            <code>-t</code> - template.json – if the user has a special template
            that is customized, then they can point to that template file
            instead of the default one that is in the program folder (in zip).
          </li>
        </ul>
        <h2>Login – Device Login Flow</h2>
        <p>
          When the user is executing the program for the first time, they have
          to login using the Device Login Flow.
        </p>

        <p>
          A message will be displayed, and the storageCLI will stop and wait for
          user action.
        </p>

        <p>
          <strong>Message:</strong>
        </p>
        <blockquote>
          <p>
            To sign in, use a web browser to open the page{" "}
            <a href="https://microsoft.com/devicelogin">
              https://microsoft.com/devicelogin
            </a>{" "}
            and enter the code <strong>&lt;CODE&gt;</strong> to authenticate.
          </p>
        </blockquote>

        <p>User should follow these steps:</p>
        <ol>
          <li>
            Open a web browser (it can be anywhere, even on a different
            computer) and go to{" "}
            <a href="https://microsoft.com/devicelogin">
              https://microsoft.com/devicelogin
            </a>
            .
          </li>
          <li>
            Copy the code from the message (for example -{" "}
            <strong>E2UEANVAD</strong> – that is the code).
          </li>
          <li>Paste the code in the textbox in the opened login window.</li>
          <li>Approve the message after login.</li>
          <li>
            Go back to the command line program – it should work after a
            successful login.
          </li>
        </ol>
        <br></br>
        <br></br>
        <br></br>
      </Col>
    </Row>
    </>
  );
};
